module.exports = __webpack_public_path__ + "static/media/navidad3.3c161d8b.webp";